import { render } from "./RoutesArchives.vue?vue&type=template&id=f09c13ac&scoped=true"
import script from "./RoutesArchives.vue?vue&type=script&lang=js"
export * from "./RoutesArchives.vue?vue&type=script&lang=js"

import "./RoutesArchives.vue?vue&type=style&index=0&id=f09c13ac&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09c13ac"]])

export default __exports__